var filter = (function() {
  let htmlTextToMobile = (str)=> {
    if(window.browserVersion.mobile){
      let scale = 750/(window.screen.width);
      str = str.replace(/font-size:\s*((\d+(\.\d+)?)px)/gi, function ($1, $2) {
        return $1.replace($2, function ($2) {
          return (parseInt($2) * scale ).toString() + 'px'
        })
      }).replace(/line-height:\s*((\d+(\.\d+)?)px)/gi, function ($1, $2) {
        return $1.replace($2, function ($2) {
          return (parseInt($2) * scale).toString() + 'px'
        })
      });
    }
    return str;
  }
  return htmlTextToMobile
})();

export default filter